import { render, staticRenderFns } from "./MiragePersonDetails.vue?vue&type=template&id=3587a5cb"
import script from "./MiragePersonDetails.vue?vue&type=script&lang=js"
export * from "./MiragePersonDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports